import { render, staticRenderFns } from "./average-rank.vue?vue&type=template&id=086bc6ea&"
import script from "./average-rank.vue?vue&type=script&lang=js&"
export * from "./average-rank.vue?vue&type=script&lang=js&"
import style0 from "./average-rank.vue?vue&type=style&index=0&id=086bc6ea&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports